import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from './login.service';
import { TranslatorService } from '../core/translator/translator.service';

@Component({
    selector: 'login-chp',
    templateUrl: './change-password.component.html'
  })

  export class ChangePasswordComponent implements OnInit {
    
    public showErrorMessage: boolean;
    public showMessage: boolean;
    public hide: boolean;
    public hideRepeat: boolean;

    private userName: string;
    private oldPassword: string;
    private password: string;
    private repeatPassword: string;
    private message : string;

    @ViewChild('changePasswordForm') changePasswordForm: NgForm;

    constructor(       
        private router: Router, 
        private route: ActivatedRoute,
        private translateService: TranslatorService,
        private loginService: LoginService
        ) { 
            this.hide = true;
            this.hideRepeat = true;
        }

    public ngOnInit() {
        if (this.route.snapshot.params['user']) {
            this.route.params.subscribe(params => {
               this.userName = params['user'];
            });
        }
    }

    public onSubmit(value: any) {
        if (this.password !== this.repeatPassword)
        {
            this.showMesage('LOGIN_diffrentPassword');
        }

        this.loginService.changePassword(this.userName, this.password, this.oldPassword).subscribe(
            token => {
              const redirectUrl = '/dashboard';
              this.router.navigate([redirectUrl]);
            },
            error => {
                if(error.message.toString().includes('kontrahent')){
                    const redirectUrl = '/login';
                    this.router.navigate([redirectUrl]);
                }
                else{
                this.showError(error);
                }
            });
    }

    showMesage(translateMessage: string) {     
        this.translateService.translate.get(translateMessage).subscribe(
            (value) => {
                this.message = value;
                this.showMessage = true;
                setTimeout(() => this.showMessage = false, 3000);
            });
      }

      showError(errorMessage: string) {
        this.message = errorMessage;
        this.showErrorMessage = true;
        setTimeout(() => this.showErrorMessage = false, 5000);   
      }
  }